export const environment = {
  env: 'DEFAULT',
  production: true,
  serverBaseUrl: 'https://bkcomprension.vaixs.net/public/api',
  serverUrl: 'https://bkcomprension.vaixs.net/public/api',
  imgUrl: 'https://bkcomprension.vaixs.net/public',

};
